// @ vendors
const React = require('react');

// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError');

// @ constants
const { COMMONS: {PRESTAMOS_PHONE} } = require('constants/mortgageRequestHolderData');

const MortgageRequestAppraisalRequestError = () => {
    const errorTitle = formatText('mortgageRequestAppraisalRequest-appraisalRequestConfirmationErrorTitle');
    const linkToAppraisal = '/myprofile/mortgage/panel';
    const returnButtonLabel = formatText('mortgageRequestAppraisalRequest-appraisalRequestErrorReturnToPanel');
    const returnMainButton = {
        label: returnButtonLabel,
        url: linkToAppraisal
    };

    return (
        <div className="row no-gutter">
            <div className="col-xs-offset-2 col-xs-8">
                <WizardError errorMessage={errorTitle} mainButton={returnMainButton}>
                    <FormattedText value="mortgageRequestAppraisalRequest-appraisalRequestConfirmationErrorMessage" injectedStrings={[PRESTAMOS_PHONE]} />
                </WizardError>
            </div>
        </div>
    )
};

module.exports = MortgageRequestAppraisalRequestError;
